import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { FormHelperService } from '../../../services/form-helper.service';
import { RichFormComponent } from '../../../components/library/rich-form/rich-form.component';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss', '../product-form.css']
})
export class ContactDetailsComponent {
  @Input() formGroupName!: string;
  @Output() isDataChanged = false;
  @Output() notifyContainerDataChanged = new EventEmitter<any>();
  formUiWidgets!: Record<string, any>[] ;
  contactDetailsForm!: FormGroup;
  savedContactData!: Record<string, any>;
  contactData!: Record<string, any>;
  isLoading = false;
  isContentScrolled = false;
  @ViewChild('contactDetailsFormComponent') contactDetailsFormComponent!: RichFormComponent;


  constructor(
    private formGroupDirective: FormGroupDirective,
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.contactDetailsForm = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
    this.formUiWidgets = this.getFormControls();
  }

  getFormControls(){
    return [
      
      { label: 'Contact Name',
        dataField: 'contactName',
        colSpan: 1, 
        width: '150px',
        validators: [
          { type: 'required' }
        ],
        FormType : 'ContactDetails'
      },
      { 
        label: 'Contact Surname',
        dataField: 'contactSurname', 
        colSpan: 1,
        width: '150px',
        validators: [
          { type: 'required' }
        ],
        FormType : 'ContactDetails'
      },
      { 
        label: 'Contact Phone Number',
        dataField: 'contactPhoneNumber', 
        colSpan: 1,
        editorType: 'dxTextBox',
        validators: [
          { type: 'required' }
        ],
        editorOptions: {
          mask: '000 000 0000',
          maskChar: '',
          onFocusIn: (e) => {
            // Ensure cursor position is managed on value change
           
            const inputElement = this.el.nativeElement.querySelector('input[id$="contactPhoneNumber"]');
            if (inputElement) {
              setTimeout(() => {
                this.renderer.selectRootElement(inputElement).focus();
                inputElement.setSelectionRange(0, 0);
                
              },210);
            }

          }
        },
        width: '150px',
        FormType : 'ContactDetails'
      },
      { 
        label: 'Email',
        dataField: 'contactEmail', 
        colSpan: 1,
        width: '150px',  
        validators: [
           { type: 'email' }, {type : 'required'}
        ],
        FormType : 'ContactDetails'
      },
    ]
  }

  dataChanged(object) {
    
    //set populated form field
    if('event' in object){

      if (typeof object.event.value === 'string' || object.event.value instanceof String) {

        let formValue: String = object.event.value;
        formValue = formValue.trim();
        if (object.event.dataField == "contactPhoneNumber") {
          formValue = formValue.replace(/\s+/g, '');  // Removes all whitespace (spaces, tabs, newlines)
        }
        this.contactDetailsForm.patchValue({
          [object.event.dataField]: formValue
        });
      }
      else {

        this.contactDetailsForm.patchValue({
          [object.event.dataField]: object.event.value
        });
      }

    }
    this.notifyContainerDataChanged.emit(object);
    
  }

  checkFormValidity() {
    const invalidControls : any = [];
    Object.keys(this.contactDetailsForm.controls).forEach(key => {
      const control = this.contactDetailsForm.get(key);
      
      if (control?.invalid) {
        invalidControls.push({ field: key, errors: control?.errors });
      }
    });
    return invalidControls;
  }

  scroll({reachedTop = false}) {
    this.isContentScrolled = !reachedTop;
  }

  cancel() {
    this.contactData = this.savedContactData,
    this.contactDetailsFormComponent.clearForm();
  }
}
